<div class="dark:bg-black p-6">
  <h3 class="pb-2 text-primary text-l font-bold">Confirm Delete Node</h3>
  <p class="text-primary dark:text-white">
      Do you really want to delete node {{device.devaddr}} / {{device.description}}?
  </p>
  <div class="mt-8">
      <button (click)="confirmDevice()" class="btn btn-primary mr-4" > Delete</button>
      <button (click)="cancelDevice()" class="btn"> Cancel </button>
  </div>
</div>
